import { Component, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, OnInit, Renderer2, Inject, PLATFORM_ID, LOCALE_ID, NgZone, DEFAULT_CURRENCY_CODE, ElementRef, AfterViewInit, ViewContainerRef, HostBinding, ComponentRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, ActivatedRoute, Event as RouterEvent, NavigationStart, NavigationEnd } from '@angular/router';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { AuthService, UserState } from './shared/auth/auth.service';
import { CartService } from './shared/cart/cart.service';
import { UtilsService } from './shared/services/utils.service';
import { NavigationService } from './shared/navigation/navigation.service';
import { Page, Settings } from './shared/navigation/pages.model';
import { OfferService } from './offer/offer.service';
import { Product } from './offer/offer.model';
import { concat, forkJoin, from, fromEvent, interval, of, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, take, skip, map, concatMap, delay, ignoreElements, repeat } from 'rxjs/operators';
import { UpdateService } from './update.service';
import { utils } from './shared/helpers/utils';
import { environment } from '../environments/environment';
import { Client } from './auth/auth.model';
import { UserService } from './user/user.service';
import { SideNavComponent } from './shared/sidenav/side-nav.component';
import { CartComponent } from './shared/cart/cart.component';
import { ArticleService } from './article/article.service';
import { Invoice } from './user/user.model';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  // animations: [
  //   trigger('.disabled', [])
  // ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class AppComponent implements OnInit, AfterViewInit {
  // @HostBinding('@.disabled') public disabled = false;

  @ViewChild('drawer') mainDrawer: SideNavComponent;
  @ViewChild('cart') cartDrawer: SideNavComponent;
  @ViewChild('cartvc', {read: ViewContainerRef}) cartvc: ViewContainerRef;
  @ViewChild('footervc', {read: ViewContainerRef}) footervc: ViewContainerRef;

  public pageName = environment.name;
  public languageMenuVisible = false;
  public languageList = [
    { code: '', label: 'Polski' },
    { code: 'en', label: 'English' },
    { code: 'fr', label: 'Français' },
    { code: 'de', label: 'Deutsch' },
    { code: 'it', label: 'Italian' },
    { code: 'es', label: 'Spanish' },
  ];
  public currencyMenuVisible = false;
  public currencyList = [
    { code: 'PLN', label: 'PLN' },
    { code: 'EUR', label: 'EUR' },
    // { code: 'USD', label: 'USD' },
  ];
  public hideBreadcrumbs = true;
  public ga4HasFired = false;
  public isLoggedIn = false;
  public isMobile = false;
  public isChat = true;
  public allowed = [1];
  public mobilePath = {shop: [], footer: []};
  public mobileMenuSectionHeight = {shop: [0], footer: [0]};
  public dropdown = 'collapsed';
  public dropdownMenuIndex = -1;
  public searchtext = $localize `Czego szukasz ?`;
  public last_activated_route = null;
  public currentNavigationIndex = -1;
  public navigation: Page[] = [];
  // public navigationShop: Page[] = [];
  public navigationFooter: Page[] = [];
  public isDropdownMultilevel = false;
  public navigationDropdown: Page[] = [];
  public navigationDropdownRecursive: Page[] = [];
  public pageRef: Page;
  public loading = false;
  public cartRef: ComponentRef<CartComponent>;
  private cartInited = false;
  public favItems = 0;
  public cdn = environment.cdn;
  public base = environment.base;
  public search = false;
  public searchmobile = false;
  public search_term = '';
  public search_ids = {articles: '', wikis: ''};
  public settings: Settings;
  public cookie_visible = true;
  public cookie_content = '';
  public products: Product[] = [];
  public articles: Product[] = [];
  public wikis: Product[] = [];
  public initialized = false;
  public breadcrumbs = [];
  public delivery = '';
  public withcode = false;
  public prices_disabled = false;
  public shopping_disabled = false;
  public pagesPerSession = 0;
  public fitter;

  public path_account = 'konto';
  public path_login = 'zaloguj';
  public path_favorites = 'schowek';
  public path_search = '/';
  public path_offer_details = '/';
  public path_articles_details = '/';
  public path_wiki_details = '/';
  public path_extra_1 = '/';
  public path_extra_2 = '/';

  public path_account_profile = '';
  public path_account_password = '';
  public path_account_orders = '';
  public path_account_invoices = '';
  public path_account_discounts = '';
  public path_account_evidence = '';
  public path_account_returns = '';
  public path_account_users = '';
  public path_account_files = '';
  public path_account_warranty = '';
  public path_account_bonuses = '';
  public path_account_contacts = '';
  public path_logout = '';

  public invoicesAfterDeadline: Invoice[] = [];
  public invoicesAfterDeadlineDays = 0;
  public invoicesBeforeDeadlineAmount = 0;

  public newContacts = 0;

  @ViewChild('term', {static: false}) term: ElementRef;

  constructor(@Inject(PLATFORM_ID) private platformId: Object, @Inject(LOCALE_ID) public localeId: string, @Inject(DEFAULT_CURRENCY_CODE) public currency: string, 
    private router: Router, private activatedRoute: ActivatedRoute, private zone: NgZone, private auth: AuthService, public cartService: CartService, private utilsService: UtilsService,
    private navigationService: NavigationService, private renderer: Renderer2, private offerService: OfferService, private articlesService: ArticleService, private usersService: UserService, 
    private cdr: ChangeDetectorRef, private breakpointObserver: BreakpointObserver, private update: UpdateService, public viewRef: ViewContainerRef) {
    
      this.router.events.subscribe((event: RouterEvent) => {
        this.navigationInterceptor(event, activatedRoute);
      });
      this.navigationService.currentPage.subscribe(this.dynamicPageChanged); // push product or article detail

      if (isPlatformBrowser(this.platformId)) {
      utilsService.setLoading();

      this.breakpointObserver
        .observe(['(min-width: 1279px)'])
        .subscribe((state: BreakpointState) => {
          if (state.matches) {
            this.isMobile = false;
            this.searchmobile = true;
            this.navigationService.mobile.next(false);
            this.cdr.markForCheck();
            // Viewport is 500px or over!
          } else {
            this.isMobile = true;
            this.navigationService.mobile.next(true);
            this.searchmobile = false;
            this.cdr.markForCheck();
            // Viewport is getting smaller!
          }
        });

      this.auth.isLoggedIn.subscribe((state: UserState) => {
        this.isLoggedIn = state.logged;
        if (this.term) {
          this.term.nativeElement.value = '';
          this.products = [];
        }

        if (state.logged) {
          this.allowed = [1,2];
        } else {
          this.allowed = [1];
        }

        if (this.isLoggedIn && isPlatformBrowser(this.platformId)) {

          const userId = +localStorage.getItem('user_id');
          const userRole = localStorage.getItem('user_role');
          const currency = localStorage.getItem('user_currency');
          const userState = localStorage.getItem('user_state') || 'confirmed';
          this.fitter = localStorage.getItem('user_fitter') || null;

          if (userState == 'unconfirmed') {

            const dialogResponse = new Subject<any>();

            dialogResponse.subscribe(data => {
              let client = new Client();
              client.id = userId;
              client.state = 1;
              client.confirmations = JSON.stringify(data);
              this.usersService.change(client).pipe(take(1)).subscribe(result => {
                this.utilsService.openDialog({
                  isSnackbar: 'success',
                  content: $localize `Twoje preferencje zostały zapisane`,
                  actionButtons: [{ text: 'OK', onAction: () => true}],
                }, this.viewRef);

                localStorage.removeItem('user_state');
              });
            });

            this.utilsService.openDialog({
              childComponent: 'LazyUserConfirmComponent',
              closeDialogSubject: dialogResponse
            }, this.viewRef);

          } else {
            this.cartService.fetchCart();
            this.cartService.fetchDiscounts({type: 3, client: userId});
            let uuid = localStorage.getItem('user_uuid') || null;
            this.usersService.favorites(userId, uuid).pipe(take(1)).subscribe(favs => {
              this.cartService.favtItems.next(favs.items || []);
            });
            if (this.fitter) {
              this.showFitterPopup();
            }
            this.fetchInvoices();
            this.getContacts();
          }
        } else {
          this.cartService.clearDiscounts();
          localStorage.removeItem('user_token');
          localStorage.removeItem('user_id');
          localStorage.removeItem('user_role');
          localStorage.removeItem('user_group');
          localStorage.removeItem('user_state');
          localStorage.removeItem('user_scopes');
          localStorage.removeItem('user_currency');
          localStorage.removeItem('user_fitter');
        }
        this.cdr.markForCheck();
      });

      this.utilsService.isLoading.subscribe((state: boolean) => {
        this.loading = state;
        this.cdr.markForCheck();
      });

      // this.cartService.fetchDiscounts({ type:0 });

      this.navigationService.code.subscribe(this.codeChanged);
      this.cartService.favtItems.pipe(skip(1)).subscribe(this.favChanged);
    }
  }

  navigationInterceptor = (event: RouterEvent, activatedRoute: ActivatedRoute) => {

    if (event instanceof NavigationStart) {
      this.last_activated_route = activatedRoute.snapshot?.firstChild?.url || '';
      this.utilsService.setLoading();
    }

    if (event instanceof NavigationEnd) {

      // const gclid = activatedRoute.snapshot.queryParamMap.get('gclid');
      // const fbclid = activatedRoute.snapshot.queryParamMap.get('fbclid');
      // const saved =  this.navigationService.getClickId().value;
      // if (gclid || fbclid || saved) {
      //   let type: string, click: string;
      //   if (gclid) {
      //     type = 'google'; 
      //     click = gclid;
      //   }
      //   if (fbclid) {
      //     type = 'facebook'; 
      //     click = fbclid;
      //   }
      //   if (saved) {
      //     type = saved.type; 
      //     click = saved.click;
      //   }
      //   this.navigationService.google_click({type: type, click: click, page: activatedRoute.snapshot?.firstChild?.url?.join('/') || '-'}).subscribe();
      //   if (gclid || fbclid) {
      //     this.navigationService.clickId.next({type: type, click: click});
      //   }
      // }

      this.breadcrumbs = [];
      activatedRoute.firstChild.url.forEach((url) => {

        const routeData = activatedRoute.firstChild.snapshot.data;
        if (routeData.hideBredcrumbs) {
        this.hideBreadcrumbs = true;
        } else {
        this.hideBreadcrumbs = false;
        }
        if (routeData.hideChat) {
        this.isChat = false;
        }else {
        this.isChat = true;
        }
        let last = '';
        for (const part of url) {
          const path = last + part.path;
          const crumb = this.router.config.find(x => x.path === path);
          if (crumb) {
            if (crumb.data['name']) this.breadcrumbs.push({label: crumb.data['name'], path: path});
          }
          last = path + '/';
        }

        this.navigationService.setMeta(
          routeData.title,
          routeData.keywords,
          routeData.description,
          routeData.canonical
        );
        
        this.closeDropdown();
        this.hideDrawer();
      });
      
      if (isPlatformBrowser(this.platformId)) {

        if (!this.ga4HasFired) {
          this.ga4HasFired = true;
          this.utilsService.gtmCustom('PageInit');
        } else {
          this.utilsService.gtmCustom('PageView');
        }

        if (this.pagesPerSession == 4) {
          this.utilsService.gtmCustom('pagesPerSession', {pageCount: 4});
        }
        this.pagesPerSession++;

        const gclid = activatedRoute.snapshot.queryParamMap.get('gclid');
        const fbclid = activatedRoute.snapshot.queryParamMap.get('fbclid');
        const utm_source = activatedRoute.snapshot.queryParamMap.get('utm_source') || null;
        const utm_medium = activatedRoute.snapshot.queryParamMap.get('utm_medium') || null;
        const utm_campaign = activatedRoute.snapshot.queryParamMap.get('utm_campaign') || null;
        const utm_term = activatedRoute.snapshot.queryParamMap.get('utm_term') || null;
        const utm_content = activatedRoute.snapshot.queryParamMap.get('utm_content') || null;
        const saved =  this.navigationService.getClickId().value;
        const stored = localStorage.getItem('a_click') || false;
        if (gclid || fbclid || saved || stored) {
          let type: string, click: string;
          if (gclid) {
            type = 'google'; 
            click = gclid;
            localStorage.setItem('a_type', type);
            localStorage.setItem('a_click', click);
          } else if (fbclid) {
            type = 'facebook'; 
            click = fbclid;
            localStorage.setItem('a_type', type);
            localStorage.setItem('a_click', click);
          } else if (saved) {
            type = saved.type; 
            click = saved.click;
          } else if (stored) {
            type = localStorage.getItem('a_type') || 'not found'; 
            click = stored;
          }

          let uuid = localStorage.getItem('uuid') || null;
          let id_client = localStorage.getItem('user_id') || null;

          this.navigationService.google_click({id_client: id_client, uuid: uuid, type: type, utm_source: utm_source, utm_medium: utm_medium, utm_campaign: utm_campaign, utm_term: utm_term, utm_content: utm_content, click: click, page: activatedRoute.snapshot?.firstChild?.url?.join('/') || '-'}).subscribe();
          if (gclid || fbclid || stored) {
            this.navigationService.clickId.next({type: type, click: click});
          }
        }
      }


      this.utilsService.clearLoading();
    }
  }

  ngOnInit() {

    this.navigationService.navigation.subscribe((setup: any) => {
      this.settings = setup.settings;
      this.navigation = setup.menu;
      this.navigationFooter = setup.footer;
      this.cookie_visible = !!+this.settings.cookies_use;
      this.cookie_content = this.settings.cookies_message;
      this.shopping_disabled = !this.settings.b2b_retail;
      this.prices_disabled = !this.settings.b2b_retail_price;

      //setup offer url
      this.path_offer_details = this.router.config.find(x => x.data?.module === 'OfferDetailsModule')?.data.path || '/';
      this.path_search = this.router.config.find(x => x.data?.module === 'OfferModule' && x.data?.level == 0)?.path || '/';
      this.path_account = this.router.config.find(x => x.data?.id === -991)?.path || '/';
      this.path_login = this.router.config.find(x => x.data?.id === -980)?.path || '/';
      this.path_favorites = this.router.config.find(x => x.data.id === -1005).path;
      this.path_extra_1 = this.router.config.find(x => x.data?.template === 'lazy2.component')?.path || '/';
      this.path_extra_2 = this.router.config.find(x => x.data?.template === 'lazy3.component')?.path || '/';


      this.path_logout = this.router.config.find(x => x.data.id === -984).path;
      this.path_account_profile = this.router.config.find(x => x.data.id === -992).path;
      this.path_account_password = this.router.config.find(x => x.data.id === -1007).path;
      this.path_account_orders = this.router.config.find(x => x.data.id === -993).path;
      this.path_account_returns = this.router.config.find(x => x.data.id === -994).path;
      this.path_account_evidence = this.router.config.find(x => x.data.id === -1006).path;
      this.path_account_discounts = this.router.config.find(x => x.data.id === -995).path;
      this.path_account_invoices = this.router.config.find(x => x.data.id === -1002).path;
      this.path_account_users = this.router.config.find(x => x.data.id === -1003).path;
      this.path_account_files = this.router.config.find(x => x.data.id === -1004).path;
      this.path_account_warranty = this.router.config.find(x => x.data.id === -1009).path;
      this.path_account_bonuses = this.router.config.find(x => x.data.id === -1008).path;
      this.path_account_contacts = this.router.config.find(x => x.data.id === -1011).path;

      //default dropdown mostly for mobile
      
      this.navigationDropdown = [...this.navigation];
      this.showCookies();
    });
  }

  ngAfterViewInit(): void {
    // if (this.term) {

    fromEvent(this.term.nativeElement, 'keyup').pipe(debounceTime(350), distinctUntilChanged()).subscribe((el: KeyboardEvent) => {
      const input = <HTMLInputElement>el.target;
      if (input.value.length > 2) {
        this.zone.run(() => {
          this.utilsService.setLoading();

            if (this.search_ids.wikis == '' || this.search_ids.articles == '') {
              this.path_articles_details = this.router.config.find(x => x.data?.module === 'ArticleDetailsModule')?.data.path || '/';
              const one = this.router.config.filter(x => x.data?.module === 'ArticleModule');
              if (one.length) this.search_ids.articles = one.map(x => x.data?.id)?.join(",") || '';
              const two = this.router.config.filter(x => x.data?.template == 'wiki');
              if (two.length) {
                this.search_ids.wikis = two.map(x => x.data?.id)?.join(",") || '';
                this.path_wiki_details = two[two.length-2].data?.path || '/';
              }


            }

            forkJoin({
              products: this.offerService.items({ title: input.value, limit: 6 }),
              articles: this.articlesService.items({ search: input.value, categories: this.search_ids.articles, pagesize: 6 }),
              wikis: this.articlesService.items({ search: input.value, categories: this.search_ids.wikis, pagesize: 6 })
            }).pipe(take(1)).subscribe((results: any) => {
              this.products = results.products.items || [];
              this.articles = results.articles.items || [];
              this.wikis = results.wikis.items || [];
              this.search = true;
              this.search_term = input.value;
              this.utilsService.clearLoading();

            });
        });
      } else {
        this.products = [];
        this.articles = [];
        this.wikis = [];
      }
      
    });
      this.loadCart();
      this.loadFooter();

      //
      // const titles = [
      //   "Czego szukasz ?",
      //   "the First of Her Name",
      //   "The Unburnt",
      // ];

      // const type = ({ word, speed, backwards = false }) =>
      //   interval(speed).pipe(
      //     map(x =>
      //       backwards ? word.substr(0, word.length - x - 1) : word.substr(0, x + 1)
      //     ),
      //     take(word.length)
      //   );

      // const typeEffect = word =>
      //   concat(
      //     type({ word, speed: 50 }), // type forwards
      //     of("").pipe(
      //       delay(1200),
      //       ignoreElements()
      //     ), // pause
      //     type({ word, speed: 30, backwards: true }), // delete
      //     of("").pipe(
      //       delay(300),
      //       ignoreElements()
      //     ) // pause
      //   );

      // // this.searchtext = useObserva(() =>
      // const result = from(titles).pipe(
      //     concatMap(typeEffect),
      //     repeat()
      //   );

      // result.subscribe(v => {
      //   this.searchtext = v;
      //   this.cdr.detectChanges();
      // });
      // );
    
    // }
  }

  searchNavigate($event: any) {
    $event.preventDefault();
    this.router.navigate(['/'+this.path_search], { queryParams: { title: this.search_term }});
    this.hideSearch();
  }

  async loadCart() {
    if (this.cartvc) {
      const { CartComponent } = await import('./shared/cart/cart.component');
      const cmp = CartComponent;
      this.cartRef = this.cartvc.createComponent(cmp);
      this.cartRef.changeDetectorRef.detectChanges();
      this.cartRef.instance.drawerToggle.subscribe(e => {
        if (e == true && this.cartInited == true) {
          this.showCart();
        } else {
          this.hideCartDrawer();
        }
        if (!this.cartInited) this.cartInited = true;
      })
    }
  }

  async loadFooter() {
    if (this.footervc) {
      const { FooterComponent } = await import('./shared/footer/footer.component');
      const cmp = FooterComponent;
      let footerRef = this.footervc.createComponent(cmp);
    }
  }

  toggleSearch() {
    this.search = !this.search;
  }
  hideSearch() {
    this.search = false;
    if (this.isMobile) this.searchmobile = false;
  }

  toggleMobileSearch() {
    this.searchmobile = !this.searchmobile;
  }

  toggleLanguageMenu() {
    this.currencyMenuVisible = false;
    this.languageMenuVisible = !this.languageMenuVisible;
  }
  toggleCurrencyMenu() {
    this.languageMenuVisible = false;
    this.currencyMenuVisible = !this.currencyMenuVisible;
  }

  changeCurrency(currencyCode: string) {
    this.cartService.updateCurrency(currencyCode);
    this.currencyMenuVisible = false;
  }

  toggleDropdown(e: MouseEvent, menuIndex = -1) {
    // if (e.type === 'click') {
    if (e.type === 'mouseenter') {
      if (menuIndex >= 0) { // && this.dropdown == 'collapsed'

        this.currentNavigationIndex = menuIndex;
        if (this.navigation[menuIndex].children?.length > 0) {

            let any_with_children = this.navigation[menuIndex].children.findIndex(p => p.children?.length > 0);
            console.log('any_with_children', any_with_children);
            if (any_with_children > -1) {
              this.isDropdownMultilevel = true;
            } else {
              this.isDropdownMultilevel = false;
            }

            this.navigationDropdown = this.navigation[menuIndex].children;
            if (this.navigation[menuIndex].children) {
              if(this.navigation[menuIndex].children[0].children) {

                let skip = 0;
                if (!this.allowed.includes(+this.navigation[menuIndex].children[0].visible)) {
                  skip = 1;
                } 

                this.navigationDropdownRecursive = this.navigation[menuIndex].children[skip].children;
                if (this.navigation[menuIndex].children[skip].extra_field_3) {
                  this.pageRef = this.navigation[menuIndex].children[skip];
                }
              } else {
                this.navigationDropdownRecursive = [];
                this.pageRef = null;
              }
            } else {
              this.navigationDropdownRecursive = [];
              this.pageRef = null;
            }
            this.dropdown = 'expanded';

        } else {
          this.dropdown = 'collapsed';
          this.currentNavigationIndex = -1;
          this.navigationDropdownRecursive = [];
          this.pageRef = null;
        }
      }
    } else if (e.type === 'mouseleave' || e.type == null) {

      this.currentNavigationIndex = -1;
      this.dropdown = 'collapsed';
      this.navigationDropdownRecursive = [];
      this.pageRef = null;
    }
  }

  closeDropdown() {
    this.currentNavigationIndex = -1;
    this.dropdown = 'collapsed';
    this.navigationDropdownRecursive = [];
    this.pageRef = null;
  }

  fillDropDown(page: Page = null) {
    if (page.children[0].module == 'container') {
      this.navigationDropdown = [];
      page.children.forEach(p => {
        this.navigationDropdown.push(p);
        p.children.forEach(pc => {
          this.navigationDropdown.push(pc);
        });
      });
    } else {
      this.navigationDropdown = page.children;
    }
  }

  showChildren(menu: string, page: Page = null) {
    if (this.isMobile) {
      this.mobilePath[menu].push(page);
      this.fillDropDown(page);
    } else {
      if (page) {
        if (page.children) {
        this.navigationDropdownRecursive = page.children;
        }
        this.pageRef = page;
      }
    } 
  }

  hideChildren(menu: string) {
    this.mobilePath[menu].splice(-1,1);
    const pathlength = this.mobilePath[menu].length-1;
    if (pathlength > -1) {
      this.fillDropDown(this.mobilePath[menu][pathlength]);
    } else {
      // this.navigationDropdown = this.navigation;
      this.navigationDropdown = [...this.navigation, ...this.navigationFooter];
    }
  }

  showDrawer() {
    if (!this.initialized) {
      this.initialized = true;
    }
    this.mainDrawer.open();
    this.renderer.addClass(document.body, 'disabled');
  }

  hideDrawer() {
    // if (window.innerWidth < 1279) {
    this.mainDrawer.close();
    this.renderer.removeClass(document.body, 'disabled');
    // }
  }

  showCart() {
    if(!this.cartRef) this.loadCart();
    this.cartDrawer.open();
    this.renderer.addClass(document.body, 'disabled');
    // this.cdr.detectChanges();
  }

  hideCartDrawer() {
    this.cartDrawer.close();
    this.renderer.removeClass(document.body, 'disabled');
    // this.cdr.detectChanges();
  }

  favChanged = (products: Product[]) => {
    this.favItems = products?.length;
    this.cdr.markForCheck();
  }

  codeChanged = (code: boolean) => {
    this.withcode = code;
    this.cdr.markForCheck();
  }

  dynamicPageChanged = (page: any) => {

    let label = null;
    if ('name' in page) {
      label = page.name;
    }
    if ('title' in page) {
      label = page.title;
    }
    if ('categories' in page) {

      // const category = page.categories.find((x: any) => x.path === this.last_activated_route);
      if (this.last_activated_route) {

        while (this.last_activated_route.length) {
          const category = page.categories.find((x: any) => x.path === this.last_activated_route.join('/'));
          if (category) {
            let add = true;
            if (this.breadcrumbs.filter(e => e.path === category.path).length > 0) {
              add = false;
            }
            if (add) this.breadcrumbs.unshift({ label: category.name, path: category.path });
          }
          this.last_activated_route.pop();
        }
        this.cdr.detectChanges();
      } else if (typeof page.categories !== 'undefined' && page.categories.length > 0){
        let lvl = -1;
        page.categories.forEach(page => {
          if (page.level > lvl) {
            this.breadcrumbs.push({ label: page.name, path: page.path });
            lvl = page.level;
          }
        });
        this.cdr.detectChanges();
      }
    }
    if (label) {
      this.breadcrumbs.push({ label: label, path: 'none' });
      this.cdr.markForCheck();
    }
  }

  goTop(){
    utils.scrollTo(0, {}, 500);
  }

  showFitterPopup() {
    this.usersService.invoices({ page: 1, pagesize: 16, only: 'extra_field_1', evidence: true, evidence_status: 1 }).pipe(take(1)).subscribe(invoices => {
      if (invoices.items && invoices.items.length) {
        this.utilsService.openDialog({
          childComponent: 'LazyEvidenceComponent',
          data: this.path_account_evidence
        }, this.viewRef);
      }
    });

  }

  fetchInvoices() {
    this.usersService.invoices({id_client: 1, status: 0}).pipe(take(1)).subscribe(invoices => {
      if(invoices.items) {
       const now = new Date();
       this.invoicesAfterDeadline = invoices.items.filter((x: Invoice) => {
        const deadline = new Date(x.deadline);
        const oneDay = 24 * 60 * 60 * 1000;
        const diffDays = Math.floor(Math.abs((now.getTime() - deadline.getTime()) / oneDay));
        if ((diffDays > this.invoicesAfterDeadlineDays) && !+x.status && (now.getTime() > deadline.getTime())) {
          this.invoicesAfterDeadlineDays = diffDays;
        }
  
        this.invoicesBeforeDeadlineAmount += +x.amount;
        if (this.invoicesAfterDeadline.length > 0) {
          this.invoicesBeforeDeadlineAmount = 0;
        }
  
        return !+x.status && (now.getTime() > deadline.getTime());
       });
  
       this.cdr.detectChanges();
      }
      if (invoices.client) {
        (<any>window).dataLayer.push({
          'userData': {
            'first_name': invoices.client.first_name,
            'last_name': invoices.client.last_name,
            'email': invoices.client.email
          }
        });
      }
    }, error => {
        console.log(error);
    });
  }

  getContacts(){
    this.usersService.contacts( { status: 'new' }).pipe(take(1)).subscribe(invoices => {
      this.newContacts = invoices.pages.totalItemCount;
      this.cdr.detectChanges();
    }, error => {
      console.log(error);
    });
  }

  showCookies() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.cookie_visible && localStorage.getItem('cookies') === null) { // 

        const dialogResponse = new Subject<any>();

       
        dialogResponse.subscribe(data => {
          localStorage.setItem('cookies', 'true');
          let additional = {};
          data.forEach(consent => {
              additional[consent.name] = consent.checked;
              localStorage.setItem(consent.name, consent.checked);
          });
          this.utilsService.gtmCustom('consent', additional);
        });

        this.utilsService.openDialog({
          childComponent: 'LazyCookieConfirmComponent',
          content: this.cookie_content,

          closeDialogSubject: dialogResponse
        }, this.viewRef);
        
      } else {
        //sent consent
        const consents = ['functionality_storage','personalization_storage','security_storage','analytics_storage', 'ad_personalization', 'ad_user_data', 'ad_storage'];
        const gtm = {};
        consents.forEach(consent => {
          let c = localStorage.getItem(consent);
          if (c != null) gtm[consent] = c;
        });
        this.utilsService.gtmCustom('consent', gtm);
      }
      // if (this.fitter) {
      //   this.showFitterPopup();
      // }
    }
  }

}

